import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';


import * as iconConstants from '../Icon/iconConstants';

import Icon from '../Icon/Icon';
import {I18nMessage} from '../../contexts/I18n';

import styles from './HelpTooltip.scss';


function HelpTooltip({tooltipContent, tooltipContentI18n}) {

    const [isTooltipVisible, setTooltipVisible] = useState(false);
    const anchorRef = useRef();
    const tooltipRef = useRef();


    const toggleToolTip = () => {

        setTooltipVisible(!isTooltipVisible);
    };

    return (
        <>
            <a
                className={styles.helpIcon}
                onClick={event => toggleToolTip(event)}
                ref={anchorRef}
            >
                <Icon icon={iconConstants.ICON_QUESTION_MARK}/>
            </a>

            {isTooltipVisible && (
                <div
                    className={styles.tooltip}
                    ref={tooltipRef}
                >
                    {tooltipContentI18n && <I18nMessage id={tooltipContentI18n}/>}
                    {tooltipContent}
                </div>
            )}
        </>
    );
}


HelpTooltip.propTypes = {
    tooltipContent: PropTypes.element,
    tooltipContentI18n: PropTypes.string
};

HelpTooltip.defaultProps = {};


export default HelpTooltip;
